import theme from '@/theme';
import styled from 'styled-components';

export const Label = styled.p`
  color: ${theme.color.gray_700};
  font-size: 14px;
  font-weight: ${theme.fontWeights[400]};
  font-family: ${theme.fonts.primary};
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 2px;
`;

export const RemoveButton = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 20px;
  position: absolute;
  right: -7px;
  top: -7px;
  background: #ff4d4d;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CustomSizeRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  margin-left: 8px;
  margin-right: 12px;
`;

export const CustomSizeField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const CustomSizeFieldLabel = styled.span`
  color: ${theme.color.gray_545454};
  font-size: 9px;
  line-height: 11px;
  font-weight: ${theme.fontWeights[500]};
  font-family: ${theme.fonts.primary};
`;

export const CustomSizeInputWrap = styled.div`
  position: relative;
  width: 108px;
  height: 40px;
  border: 1px solid ${theme.color.gray_200};
  border-radius: 8px;
  background-color: ${theme.color.white};
  box-sizing: border-box;
  transition: border-color 0.15s ease;

  &:focus-within {
    border-color: ${theme.color.primary};
  }
`;

export const CustomSizeInput = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
  padding: 6px 32px 6px 10px;
  box-sizing: border-box;
  background: transparent;
  color: ${theme.color.gray_700};
  font-size: 14px;
  line-height: 20px;
  font-family: ${theme.fonts.primary};
  color-scheme: light;
  appearance: textfield;

  &:focus {
    outline: none;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const CustomSizeUnit = styled.span`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: ${theme.color.gray_545454};
  font-size: 12px;
  line-height: 16px;
  font-family: ${theme.fonts.primary};
  pointer-events: none;
`;

export const CustomSizeSeparator = styled.span`
  color: ${theme.color.gray_700};
  font-size: 20px;
  line-height: 20px;
  font-weight: ${theme.fontWeights[400]};
  padding-bottom: 8px;
  font-family: ${theme.fonts.primary};
`;

export const CustomSizeError = styled.span`
  color: #d32f2f;
  font-size: 11px;
  margin-left: 4px;
`;
